import { render } from "./mail-attachments-button.vue?vue&type=template&id=1dcdab29&scoped=true"
import script from "./mail-attachments-button.vue?vue&type=script&lang=js"
export * from "./mail-attachments-button.vue?vue&type=script&lang=js"

import "./mail-attachments-button.vue?vue&type=style&index=0&id=1dcdab29&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-1dcdab29"]])

export default __exports__